"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyndicationSectionDeals = void 0;
var SyndicationSectionDeals;
(function (SyndicationSectionDeals) {
    //----DEPRECATED----
    SyndicationSectionDeals["new_deals"] = "new_deals";
    SyndicationSectionDeals["live_deals"] = "live_deals";
    SyndicationSectionDeals["archive_deals"] = "archive_deals";
    //----DEPRECATED----
    SyndicationSectionDeals["newDeals"] = "new_deals";
    SyndicationSectionDeals["liveDeals"] = "live_deals";
    SyndicationSectionDeals["archiveDeals"] = "archive_deals";
})(SyndicationSectionDeals = exports.SyndicationSectionDeals || (exports.SyndicationSectionDeals = {}));
//# sourceMappingURL=SyndicationDeals.js.map